import { type ReactNode } from 'react';

import { memoWithDisplayName } from '@/packages/utils';

import { DepositPropertyLabel } from './components/DepositPropertyLabel';
import { BestPlaceAnalyticsLabelContainer } from './containers/BestPlaceAnalyticsLabelContainer';
import { CoworkingsBenefitsLabelContainer } from './containers/CoworkingsBenefitsLabelContainer';
import { EarlyAccessLabelContainer } from './containers/EarlyAccessLabelContainer';
import { FromOwnerLabelContainer } from './containers/FromOwnerLabelContainer';
import { FromSuperAgentLabelContainer } from './containers/FromSuperAgentLabelContainer';
import { GoodPriceLabelContainer } from './containers/GoodPriceLabelContainer';
import { NoFeeLabelContainer } from './containers/NoFeeLabelContainer';
import { UniqueForCianLabelContainer } from './containers/UniqueForCianLabelContainer';
import { WithAuctionLabelContainer } from './containers/WithAuctionLabelContainer';

type LabelType =
  // Доступна геоаналитика от BestPlace
  | 'bestPlaceAnalytics'
  // Это выгодно
  | 'coworkingBenefits'
  // Залоговое имущество
  | 'depositProperty'
  // От собственника
  | 'fromOwner'
  // Проверенный собственник
  | 'fromOwnerChecked'
  // От супер агента
  | 'fromSuperAgent'
  // Хорошая цена
  | 'goodPrice'
  // Без комиссии
  | 'noFee'
  // Уникально на Циан
  | 'uniqueForCian'
  // Объект размещён на открытом аукционе
  | 'withAuction'
  // Ранний доступ
  | 'earlyAccess';

type LabelContainerProps = {
  type: LabelType;
};

export const CardLabelContainer = memoWithDisplayName(({ type }: LabelContainerProps): ReactNode => {
  switch (type) {
    case 'fromSuperAgent':
      return <FromSuperAgentLabelContainer />;
    case 'bestPlaceAnalytics':
      return <BestPlaceAnalyticsLabelContainer />;
    case 'coworkingBenefits':
      return <CoworkingsBenefitsLabelContainer />;
    case 'depositProperty':
      return <DepositPropertyLabel />;
    case 'fromOwner':
      return <FromOwnerLabelContainer />;
    case 'goodPrice':
      return <GoodPriceLabelContainer />;
    case 'uniqueForCian':
      return <UniqueForCianLabelContainer />;
    case 'noFee':
      return <NoFeeLabelContainer />;
    case 'earlyAccess':
      return <EarlyAccessLabelContainer />;

    case 'withAuction':
      return <WithAuctionLabelContainer />;
    default:
      return null;
  }
}, 'Label');
